'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/weeksAfter.js
// module id = 389
// module chunks = 1